import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

// Dev local — si `local-services.json` registra el path de esta request,
// la redirige a `http://localhost:<port>` (lambda corriendo en `sam local
// start-api`) en vez de al API Gateway de dev. Sin registro, no-op.
@Injectable()
export class LocalOverrideInterceptor implements HttpInterceptor {
  constructor(private config: ConfigService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const override = this.config.resolveLocalOverride(request.url);
    if (override) {
      request = request.clone({ url: override });
    }
    return next.handle(request);
  }
}
